import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';
import { sanitizeActionParams } from '../../../shared/workspace-element-context';

@Injectable({ providedIn: 'root' })
export class QreEntityDetailsService {
  constructor(private http: HttpClient) {}

  loadData(baseUrl: string, actionCode: string, params: Record<string, any>): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=${actionCode}`;
    const safeParams = sanitizeActionParams(params);
    const urlEncoded = new URLSearchParams();
    Object.keys(safeParams).forEach(key => {
      if (safeParams[key] !== undefined && safeParams[key] !== null) {
        urlEncoded.set(key, String(safeParams[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveData(
    baseUrl: string,
    actionCode: string,
    jsonObj: any[],
    jsonSettings: Record<string, any>,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=${actionCode}`;
    let params: any = { ...(filterParams || {}) };
    params = _.merge({}, globalService?.globalParams || {}, params);
    params = _.extend({ jsonObj: JSON.stringify(jsonObj || []) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings || {}) }, params);
    params.process_name = 'QRE_ENTITY_DETAILS_SAVE';
    if (!params.checkLockedbj) {
      const scenarioKey = filterParams?.scenario || globalService?.globalParams?.scenario;
      params.checkLockedbj = JSON.stringify([{ scenario_key: parseInt(String(scenarioKey || '0'), 10) }]);
    }
    params = sanitizeActionParams(params);
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
